import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateIdle extends PlayerState {
    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.Idle);
    }

    beginState(): void {
        super.beginState();
    }

    shutDown(): void {
        super.shutDown();
    }
}